var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KPage',[_c('FormSupply',{attrs:{"errors":_vm.errors,"show-condominium":true},on:{"click:save":_vm.save}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }